import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

var NullAnalytics = /*#__PURE__*/function () {
  function NullAnalytics() {
    _classCallCheck(this, NullAnalytics);
  }

  _createClass(NullAnalytics, [{
    key: "sendEvent",
    value: function sendEvent() {}
  }]);

  return NullAnalytics;
}();

export default NullAnalytics;